import { Scope } from '@/typings/fe';

export const ScopesMap: Record<
  Exclude<Scope, 'synthesize' | 'other' | 'merchant'>,
  string
> = {
  'mini-app': '小程序',
  'mini-game': '小游戏',
};
